import React from "react";
import Checkbox from "../Checkbox";
import Accordion from "../Accordion";
import OutputFactory from "../OutputFactory";
import CollapseView from "./CollapseView";
import { motion } from "framer-motion";
import AccordionProvider from "../Accordion/AccordionProvider";
import AccordionCollapse from "../Accordion/AccordionCollapse";
import { container, item } from "../../utils/animationUtils";

let timeoutId;

function Body({
  objects,
  fields,
  selected,
  selectable,
  onSelect,
  onLongPress,
  actionsList,
  collapsable,
  onCollapse,
  toggleable,
  actions,
  onClickItem,
  fieldImage,
}) {
  const onPointerDown = () => {
    timeoutId = setTimeout(onLongPress, 500); // set long press time to 500ms
  };

  const onPointerUp = () => {
    clearTimeout(timeoutId);
  };

  return objects.map((object, index) => {
    const id = object.id || object._id;
    const safeId = (id || "").replace(/[^a-zA-Z0-9_-]/g, "_");
    const checked = selected.includes(object);
    return (
      <AccordionProvider key={id}>
        <motion.tr variants={container(0.1)} initial="hidden" animate="show">
          {selectable && (
            <th className="align-middle">
              <Checkbox
                checked={checked}
                id={"check_" + safeId}
                onChange={() => onSelect(index)}
              />
            </th>
          )}

          {Object.keys(fields).map((field, i) => {
            const options = fields[field];
            return (
              <Accordion
                as={motion.td}
                variants={item}
                eventKey={`_${safeId}`}
                key={field}
                className="fs-sm text-truncate text-center"
                onPointerDown={onPointerDown}
                onPointerUp={onPointerUp}
                // style={{
                //   cursor: "pointer",
                //   maxWidth: "15em",
                //   color:
                //     field === "credit"
                //       ? object?.operation === "Add"
                //         ? "#dc3545"
                //         : "#28a745"
                //       : "black",
                // }}
                style={{
                  cursor: "pointer",
                  maxWidth: "15em",
                  color:
                    field === "credit"
                      ? object?.operation === "Add"
                        ? "#dc3545"
                        : "#3B82F6"
                      : field === "rate"
                        ? "#6B7280"
                        : field === "php"
                          ? "#10B981"
                          : field === "status" &&
                              object?.status === "Request for Access"
                            ? "#dc3545"
                            : "black",
                  fontWeight:
                    field === "credit" || field === "php" ? "600" : "normal",
                }}
                // style={{
                //   cursor: "pointer",
                //   maxWidth: "15em",
                //   color:
                //     field === "credit"
                //       ? object?.operation === "Add"
                //         ? "#dc3545"
                //         : "#28a745"
                //       : field === "status" &&
                //         object?.status === "Request for Access"
                //       ? "red"
                //       : "black",
                // }}
              >
                <OutputFactory field={field} object={object} {...options} />
              </Accordion>
            );
          })}

          {actionsList.length > 0 && (
            <td>
              <div style={{ width: "50px" }}></div>
            </td>
          )}
          {actionsList.map((action) => {
            return (
              <td className="text-truncate">
                <button
                  onClick={action.onClick && action.onClick.bind(this, index)}
                  className="btn btn-outline-primary btn-sm fs-xs shadow-none"
                >
                  <i className={action.icon} /> {action.label}
                </button>
              </td>
            );
          })}
        </motion.tr>
        {collapsable && (
          <tr>
            <td className="p-0" colSpan={Object.keys(fields).length + 1}>
              <AccordionCollapse
                toggleable={toggleable}
                className="collapse"
                eventKey={`_${safeId}`}
              >
                <div className="p-3">
                  {onCollapse(index, object) ||
                    CollapseView(
                      index,
                      object,
                      fields,
                      actions,
                      onClickItem,
                      fieldImage,
                    )}
                </div>
              </AccordionCollapse>
            </td>
          </tr>
        )}
      </AccordionProvider>
    );
  });
}

export default Body;
